import React from 'react'
import { getPerformanceColor } from '../lib/financial-utils'

interface CircularProgressProps {
  percentage: number
  size?: number
}

const CircularProgress = ({ percentage, size = 60 }: CircularProgressProps) => {
  const radius = (size - 8) / 2
  const circumference = radius * 2 * Math.PI
  const strokeDasharray = `${(percentage / 100) * circumference} ${circumference}`

  return (
    <div className="relative animate-fade-in" style={{ width: size, height: size }}>
      <svg
        className="transform -rotate-90 drop-shadow-sm"
        width={size}
        height={size}
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="currentColor"
          strokeWidth="4"
          fill="transparent"
          className="text-brand-dark-lighter"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="currentColor"
          strokeWidth="4"
          fill="transparent"
          strokeDasharray={strokeDasharray}
          className={`${getPerformanceColor(percentage)} transition-all duration-500`}
          style={{
            strokeLinecap: 'round',
            strokeDashoffset: 0,
          }}
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className={`text-sm font-bold font-display ${getPerformanceColor(percentage).replace('stroke-', 'text-')}`}>
          {percentage}%
        </span>
      </div>
    </div>
  )
}

export default CircularProgress